<script>
	import SuperForm from '$lib/Components/Forms/SuperForm/SuperForm.svelte';
	import SuperInput from '$lib/Components/Forms/SuperInput/SuperInput.svelte';
	import leadSchema from '$lib/PageSections/Forms/schemas/lead.schema.js';

	let {
		data = null,
		disabled = null,
		buttonText = 'Submit',
		action = '/forms/measure-support',
		class: className = '',
		text,
	} = $props();
</script>

<p class="col-span-full mb-4 p-0 text-left text-sm text-indow-grey-dark!">
	{#if text}{@render text()}{:else}
		<span>
			Fill out this form and one of our Comfort Experts will be in touch to
			prepare a specialized estimate for your space.
		</span>
	{/if}
</p>
<SuperForm
	{data}
	{disabled}
	{buttonText}
	formName="measure-support"
	method="POST"
	sendPixelEvents
	schema={leadSchema}
	{action}
	class={className}
>
	{#snippet children({ form, disabled })}
		<SuperInput
			{form}
			{disabled}
			name="firstName"
			label="First Name"
			autocomplete="given-name"
		/>
		<SuperInput
			{form}
			{disabled}
			name="lastName"
			label="Last Name"
			autocomplete="family-name"
			required
		/>
		<SuperInput
			{form}
			{disabled}
			type="email"
			name="email"
			label="Email"
			autocomplete="email"
			required
			class="col-span-full"
		/>

		<SuperInput
			{form}
			{disabled}
			name="supportOrderNumber"
			type="text"
			label="Order Number"
			class="col-span-full"
		/>
		<SuperInput
			{form}
			{disabled}
			name="supportIssue"
			type="select"
			label="I Need Help With"
			options={[
				{
					value:
						'Entering dimensions online / getting access to Measure by Indow Portal',
					label:
						'Entering dimensions online / getting access to Measure by Indow Portal',
				},
				{ value: 'Measuring my windows', label: 'Measuring my windows' },
				{
					value: 'Assistance with using Measure by Indow system',
					label: 'Assistance with using Measure by Indow system',
				},
				{
					value: 'Getting my window measurements to validate',
					label: 'Getting my window measurements to validate',
				},
				{ value: 'Other (please specify)', label: 'Other (please specify)' },
			]}
			required
			class="col-span-full"
		/>

		<SuperInput
			{form}
			{disabled}
			name="supportNotes"
			type="textarea"
			label="How can we help you? (optional)"
			class="col-span-full"
		/>
	{/snippet}
</SuperForm>
